var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');
var gallery = require('rrViewComponents/Gallery/GalleryComponent/sw-gallery.js');

var mountedFragment = function mountedFragment() {
  this.$nextTick(function () {
    var $el = $(this.$el);
    gallery($el);
  });
};

/*
  This creates a new VUE instance for element's with data-sw-material-page. This is the js for the material pages which live in the cms.
  Note: the gallery component's js which we require above has to be initialized everytime vue re-renders.
  TODO -> remove gallery js initialization from this vue instance once gallery component is ported over to vue
 */
module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-material-page]").each(function () {

    new Vue({
      el: this,
      data: {
        materialInfoVisible: true,
        designGuidelinesVisible: false
      },
      mounted: mountedFragment,
      methods: {
        materialInfoTabClicked: function(event){
          var $el = $(event.currentTarget);
          gallery($el);
          this.materialInfoVisible = true;
          this.designGuidelinesVisible = false;
        },
        designGuidelineTabClicked: function(event){
          var $el = $(event.currentTarget);
          gallery($el);
          this.designGuidelinesVisible = true;
          this.materialInfoVisible = false;
        }
      }
    });

    //TODO -> is there anyway I can accomplish this in Vue?
    var clickTriggeredScroll = false;
    var selectedGuidelineSection = $('.selected-guideline-section');
    $('[data-sw-guideline-nav-item]').on('click', function (event) {
      selectedGuidelineSection.toggleClass('selected-guideline-section');
      var navItem = $(event.target);
      navItem.addClass('selected-guideline-section');
      selectedGuidelineSection = navItem;

      var val = navItem.data('swGuidelineNavItem');
      var selectedDataAttr = '[data-sw-guideline-section=' + val + ']';
      var selectedSection = $(selectedDataAttr);
      var scrollTop = selectedSection.offset().top;
      clickTriggeredScroll = true;
      $('html, body').stop();
      $('html, body').animate({
        scrollTop: scrollTop
      }, 500, function(){
        clickTriggeredScroll = false;
      });
    });

    var $outerDesignGuidelineSection =$('[data-sw-design-guideline-section]');
    var $designGuidelineContainer = $('[data-sw-design-guideline-container]');
    var $designGuidelineNav = $('[data-sw-guideline-nav]');
    var materialInfoTab = $('[data-sw-material-page-information-tab]');
    var $guidelineSection = $('[data-sw-guideline-section]');

    $(window).scroll(function (){
      if($outerDesignGuidelineSection.is(':visible')){
        var winScrollTop = $(window).scrollTop();
        var designGuidelineContainerHeight = $designGuidelineContainer.height();
        var designGuidelineContainerTop = $designGuidelineContainer.offset().top

        var designGuidelineNavHeight = $designGuidelineNav.height();
        var lastAnchorPoint = (designGuidelineContainerHeight - designGuidelineNavHeight) - 25;

        var topPropertyStr = lastAnchorPoint + "px";

        var materialInfoTabLeftOffset = materialInfoTab.offset().left;
        var materialInfoTabLeftOffsetStr = materialInfoTabLeftOffset + 'px';

        if (winScrollTop > designGuidelineContainerTop && winScrollTop < (lastAnchorPoint + designGuidelineContainerTop)) {
          $designGuidelineNav.css({position: 'fixed', top: '10px', left: materialInfoTabLeftOffsetStr});
        }
        else if (winScrollTop > lastAnchorPoint) {
          $designGuidelineNav.css({position: 'absolute', top: topPropertyStr, left: '10.07%'});
        }
        else {
          $designGuidelineNav.css({position: 'absolute', top: 0, left: '10.07%'});
        }

        $guidelineSection.each(function(){
          var $this = $(this);
          var topOffset = $this.offset().top;
          if (winScrollTop >= topOffset && !clickTriggeredScroll) {
            var val = $this.data('swGuidelineSection');
            var $navItem = $('[data-sw-guideline-nav-item=' + val+']');
            selectedGuidelineSection.toggleClass('selected-guideline-section');
            $navItem.addClass('selected-guideline-section');
            var $nav = $navItem.parent();
            var navItemLeftOffset = $navItem[0].offsetLeft;
            $nav.scrollLeft(navItemLeftOffset);
            selectedGuidelineSection = $navItem;
          }
        });
      }
    });

  });
};
